<script lang="ts">
  import FeatureTag from '../../tag/FeatureTag.svelte';
  import TimerTag from '../../tag/TimerTag.svelte';
  import JoodRemainingQty from './JoodRemainingQty.svelte';
  // export let tagsData = [];
  // export let isMegasaleProduct = [];
  export let data: any;
  export let joodDayData: any;
  export let isPLPGrid: boolean = false;
  const { isJoodDayFlag, joodDayRemainingQuantity } = joodDayData;
</script>

{#if data}
  <div class="bottom-tag-conatiner sticky-conatiner">
    {#if joodDayRemainingQuantity > 0 && isJoodDayFlag !== 'NOPRIME'}
      <JoodRemainingQty {isJoodDayFlag} {joodDayRemainingQuantity} />
    {/if}
    {#each data?.tagsData as tagData}
      {#if tagData && Object.keys(tagData).length && !tagData.timerTag}
        <FeatureTag {isPLPGrid} {...tagData} isMegasaleProduct={data?.isMegasaleProduct} />
      {:else if tagData?.timerTag}
        <TimerTag {...tagData} />
      {/if}
    {/each}
  </div>
{/if}

<style lang="scss">
  @import '../../../styles/colors.new.scss';
  .bottom-tag-conatiner {
    display: flex;
    flex-direction: row-reverse;
    width: 100%;
    gap: 4px;
    &.sticky-conatiner {
      // position: absolute;
      // left: 0;
      // right: 0;
      margin-top: -8px;
      scrollbar-width: none; /* Also needed to disable scrollbar Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      @include desktop-min-width {
        overflow-x: scroll;
        margin-top: -12px;
      }
    }
  }
  :global {
    .bottom-tags-section {
      .c_jooddayremaingqty {
        font-size: 10px;
        min-width: 100px;
        @include responsive {
          gap: 2px;
        }
        .c_icon_new {
          font-size: 13px;
        }
        .qty {
          font-size: 10px;
        }
      }
    }
    .tag-wrapper {
      align-items: center;
      display: flex;
    }

    .product-list-section {
      .bottom-tags-section {
        .c_jooddayremaingqty,
        .tag-wrapper {
          font-size: 14px !important;
        }
      }
    }

    @include responsive {
      .rich-relevance-container {
        .tile-content-wrapper .bottom-tags-section {
          width: 100% !important;
        }
      }
    }
  }
</style>
